import {
  SET_MENU_EXTRAS_DATA,
  TOGGLE_EXTRA_MODAL,
  TOGGLE_SECTION_MODAL,
  SET_MENU_ITEMS_DATA
} from './constants';

const initialState = {
  list: null,
  sectionId: null,
  extraModal: false,
  sectionModal: false,
  menuItems: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MENU_EXTRAS_DATA:
      return {
        ...state,
        list: action.payload
      };
    case TOGGLE_EXTRA_MODAL:
      return {
        ...state,
        extraModal: action.payload.value,
        sectionId: action.payload.id
      };
    case SET_MENU_ITEMS_DATA:
      return {
        ...state,
        menuItems: action.payload,
      };
    case TOGGLE_SECTION_MODAL:
      return {
        ...state,
        sectionModal: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;